module.exports = __webpack_public_path__ + "img/full-screen.893d1ce3.svg";